import classNames from 'classnames';
import React from 'react';
import BlogEntryComponent from '../MerchantBlogEntry';
import { MerchantBlogEntry } from '../../../../interfaces/merchants/blogs';
import css from './MerchantBlogEntries.module.scss';

export interface BlogEntries {
  blogPosts: MerchantBlogEntry[];
}

const MerchantBlogEntries: React.FC<BlogEntries> = ({ blogPosts }) => {
  const classes = classNames(css.MerchantBlogEntries);

  return (
    <div className={classes}>
      {blogPosts.map((blogPost) => {
        return (
          <BlogEntryComponent key={blogPost.public_id} blogPost={blogPost} />
        );
      })}
    </div>
  );
};

export default MerchantBlogEntries;
